export const constraintKeys = {
  all: ['constraints'] as const,
  list: (userId?: number) => [...constraintKeys.all, 'list', userId] as const,
};

export const exclusionKeys = {
  all: ['meal-exclusions'] as const,
  list: (userId?: number) => [...exclusionKeys.all, 'list', { userId }] as const,
  byMeal: (mealId: number) =>
    [...exclusionKeys.all, 'byMeal', mealId] as const,
};
